import React, { useEffect } from 'react'
import { useGlobalContext } from '../Context';
import S from '../../pages/ListDam.module.css'
import apiService from '../../api/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import { addTohistories } from '../../redux/slices/adminSlice';
const moment=require('moment-jalaali')

const StatusHistoryCompare = ({SData,flag}) => {
  
    const dispatch=useDispatch()
    const {data}=useSelector(state=>state.p.admin)
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    
    const toggleCycleHistory=async()=>{
        if(!SData?.isReaded){
          const res=await apiService.readCycleHistory(SData?.id)
          const filter=data.filter(item=>{
            
            return item.id!==SData.id
        })
        dispatch(addTohistories(filter))
        }
    }
    const toggleStatusHistory=async()=>{
        if(!SData?.isReaded){
          const res=await apiService.readStatusHistory(SData?.id)
          const filter=data.filter(item=>{
            
            return item.id!==SData.id
        })
        dispatch(addTohistories(filter))
      }
    }
    useEffect(()=>{
        if(flag==='cycle'){
            toggleCycleHistory()
        }
        if(flag==='status'){
            toggleStatusHistory()
        }
    },[])
  return (
    <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <div className="editModalDamCon2 Ani AllFFFF">
        <div className={S.AnimContentLI} data-aos='fade'>
      <table>
        
        <tr>
    <th >مشخصات</th>
    <th>مقدار قدیم</th>
    <th>مقدار جدید</th>
  </tr>
  <tr>
    <td> {SData?.oldCattleStatusTitle?'وضعیت':'چرخه'} </td>
    <td>{SData?.oldCattleStatusTitle||SData?.oldCattleLifeCycleTitle}</td>
    <td>{SData?.newCattleStatusTitle||SData?.newCattleLifeCycleTitle}</td>
  </tr>
  
  
      </table>
    </div>
    </div>


    </div>
    
  )
}

export default StatusHistoryCompare
